/**
 * uscitaSicura — il campo che si stava scrivendo non si perde se la pagina
 * se ne va (24 settembre 2026, dopo la prova di Alex).
 *
 * IL DIFETTO. I campi si salvano da soli quando se ne esce (regola di Alex,
 * CLAUDE.md). Ma chiudere la scheda del browser, ricaricare o chiudere il
 * portatile NON fa uscire dal campo: nessun «blur», nessun salvataggio.
 * Prima c'era il «Salva» e chi chiudeva sapeva di non aver salvato; adesso
 * si fida. Provato da Alex: voce d'anamnesi, testo scritto, scheda chiusa
 * senza uscire dal campo, testo perso.
 *
 * LA CORREZIONE, IN DUE PEZZI, UNA COPIA SOLA PER TUTTA L'APPLICAZIONE:
 *   1. quando la pagina viene nascosta o scaricata (`visibilitychange` a
 *      hidden, `pagehide`) e il campo attivo e' un campo che si salva da
 *      solo ed e' stato scritto, lo si fa USCIRE (`blur`): parte il suo
 *      salvataggio di sempre, con le sue regole e i suoi controlli, e le
 *      richieste di quel momento viaggiano con `keepalive` (services/api.js
 *      lo legge da `inUscita()`), cioe' il browser le porta a termine anche
 *      a pagina chiusa. Non c'e' una seconda strada di scrittura da tenere
 *      allineata: e' la stessa.
 *   2. se si prova a chiudere o ricaricare con un campo scritto e non
 *      ancora uscito, il browser mostra il suo avviso (`beforeunload`): il
 *      salvataggio del punto 1 parte lo stesso, ma chi scrive lo sa.
 *
 * QUALI CAMPI: quelli dentro un contenitore con l'attributo
 * `data-salva-da-solo`. Una casella di ricerca o un filtro non lo hanno, e
 * scriverci dentro non fa comparire nessun avviso.
 *
 * Il testo NON si mette in localStorage per ritrovarlo dopo: le postazioni
 * sono condivise (vedi utils/salvaCampo.js).
 */

let scrittoNelCampo = false;
let uscita = false;
let installato = false;

/** Le richieste di adesso devono sopravvivere alla chiusura della pagina? */
export const inUscita = () => uscita;

const campoAutomatico = (el) => !!(el && el.closest && el.closest('[data-salva-da-solo]'));

function fai_uscire() {
    const el = document.activeElement;
    if (!scrittoNelCampo || !campoAutomatico(el)) return;
    uscita = true;
    el.blur();
}

export function installaUscitaSicura() {
    if (installato || typeof window === 'undefined') return;
    installato = true;
    document.addEventListener('input', (e) => {
        if (campoAutomatico(e.target)) scrittoNelCampo = true;
    }, true);
    /* Uscire dal campo lo salva (lo fa il componente): da li' in poi non
       c'e' piu' niente di scritto e non uscito. */
    document.addEventListener('focusout', () => { scrittoNelCampo = false; }, true);
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') fai_uscire();
        else uscita = false;
    });
    window.addEventListener('pagehide', fai_uscire);
    window.addEventListener('beforeunload', (e) => {
        if (!scrittoNelCampo || !campoAutomatico(document.activeElement)) return;
        e.preventDefault();
        e.returnValue = '';
    });
}
